import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, Trash2 } from "react-feather";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import confirmDelete from "../components/confirmDelete";
import DoctorModal from "../../core/modals/doctors/DoctorModal";
import { fetchDoctors, deleteDoctorThunk } from "../../core/redux/slices/doctorSlice";

const DoctorList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.doctors);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => { dispatch(fetchDoctors()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter((d) => !q || d.doctorName?.toLowerCase().includes(q) || d.specialization?.toLowerCase().includes(q));
  }, [list, search]);

  const openAdd = () => { setEditRecord(null); setShowModal(true); };
  const openEdit = (rec) => { setEditRecord(rec); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditRecord(null); dispatch(fetchDoctors()); };

  const columns = [
    { title: "Doctor Name", dataIndex: "doctorName", sorter: (a, b) => a.doctorName.localeCompare(b.doctorName) },
    { title: "Specialization", dataIndex: "specialization" },
    { title: "Mobile", dataIndex: "mobileNumber", width: 130 },
    { title: "Availability", dataIndex: "availabilitySchedule" },
    { title: "Status", dataIndex: "status", width: 90,
      render: (v) => <span className={`badge bg-${v === "Active" ? "success" : "danger"}`}>{v}</span> },
    {
      title: "Action", dataIndex: "action", width: 100,
      render: (_, rec) => (
        <div className="edit-delete-action d-flex">
          <button className="me-2 p-2 btn btn-sm" onClick={() => openEdit(rec)}><Edit size={15} /></button>
          <button className="p-2 btn btn-sm text-danger" onClick={() => confirmDelete(() => dispatch(deleteDoctorThunk(rec.id)), rec.doctorName)}>
            <Trash2 size={15} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Doctors" subtitle="Manage clinic doctors" onAdd={openAdd} addLabel="Add Doctor" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-input">
                <input type="text" placeholder="Search by name or specialization..."
                  className="form-control form-control-sm formsearch"
                  value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <DoctorModal show={showModal} onClose={closeModal} editRecord={editRecord} />
    </div>
  );
};

export default DoctorList;
